$(() => {
	const parentDiv = document.querySelector('.bs-div--contact-us-form');
	if (document.querySelector('.bs-div--contact-us-form') !== null) {
		const isStylable = (el) => {
			return el.querySelector('div.mktoFieldWrap') !== null;
		};

		const fixFormLayout = () => {
			document.querySelectorAll('.mktoFormRow').forEach((el, index) => {
				if (isStylable(el)) {
					el.classList.add('grid-item');
					makeTextareaParent(el);
				}
			});

			updateFormStatus();

			const mktoForm = document.querySelector('form.mktoForm');
			if (!mktoForm) return;

			const mObserver = new MutationObserver((mutationList, observer) => {
				for (const mutation of mutationList) {
					if (
						mutation.type === 'childList' &&
						mutation.target.nodeName === 'DIV' &&
						mutation.target.classList.contains('mktoFormRow')
					) {
						if (isStylable(mutation.target)) {
							makeTextareaParent(mutation.target);
							mutation.target.classList.add('grid-item');
						} else {
							mutation.target.classList.remove('grid-item');
						}
					}
				}
				updateFormStatus();
			});

			mObserver.observe(mktoForm, {
				attributes: false,
				childList: true,
				subtree: true,
			});
			window.addEventListener('unload', () => mObserver.disconnect());
		};

		const makeTextareaParent = (row) => {
			row.querySelectorAll('textarea , .mktoHtmlText, #LbloptIn').forEach(
				() => row.classList.add('full-width')
			);
		};

		const updateFormStatus = () => {
			const contactUsInquiryTypeField = document.getElementById(
				'contactUsInquiryType'
			);
			const type = contactUsInquiryTypeField.value;
			const classList = contactUsInquiryTypeField.form.classList;

			if (type === 'Patient Support') {
				classList.add('submit-button-disabled');
			} else {
				classList.remove('submit-button-disabled');
			}

			if (type === '' || type === null) {
				classList.add('form-closed');
				classList.remove('form-opened');
				parentDiv.classList.add('form-closed');
				parentDiv.classList.remove('form-opened');
				return;
			}
			classList.remove('form-closed');
			classList.add('form-opened');
			parentDiv.classList.remove('form-closed');
			parentDiv.classList.add('form-opened');
		};
		(() => {
			if (typeof MktoForms2 !== 'undefined') {
				MktoForms2.loadForm(
					'//content.castlighthealth.com',
					'785-UHP-775',
					1057
				).whenReady(fixFormLayout);
			}
		})();
	}
});
